import t from "react";
import { useTranslation as c } from "react-i18next";
import i from "../../../hooks/customization/useCustomization.js";
import n from "../bookingForm.module.scss.js";
function p() {
  const { t: s } = c(), {
    getTextTranslations: o
  } = i(), e = o("booking");
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "success-step" }, /* @__PURE__ */ t.createElement("div", { className: n.title }, (e == null ? void 0 : e.success_title) || s("shopLanding.book.success.title")), /* @__PURE__ */ t.createElement(
    "div",
    {
      style: {
        fontSize: "14px"
      }
    },
    (e == null ? void 0 : e.success_text) || s("shopLanding.book.success.text")
  ));
}
export {
  p as SuccessStep
};
//# sourceMappingURL=SuccessStep.js.map
